module.exports = __webpack_public_path__ + "static/media/crispycorn.b08ccd41.jpg";